<!-- Animated Background -->
<div class="background-animation">
    <div class="gradient-orb orb-1"></div>
    <div class="gradient-orb orb-2"></div>
    <div class="gradient-orb orb-3"></div>
</div>

<!-- Login Container -->
<main class="login-container">
    <div class="login-card">
        <!-- Header -->
        <header class="login-header">
            <h1 class="brand-title">Suntur Quri Wasi</h1>
            <p class="brand-subtitle">Panel de Administración</p>
        </header>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form" novalidate>
            <!-- Usuario Field -->
            <div class="form-group">
                <label for="usuario" class="form-label">Usuario</label>
                <div class="input-wrapper">
                    <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <input type="text" id="usuario" formControlName="usuario" class="form-input" [ngClass]="{
              'error': shouldShowError('usuario'),
              'success': isFieldSuccess('usuario')
            }" placeholder="Ingrese su usuario" autocomplete="username" (blur)="markAsTouched('usuario')"
                        (focus)="clearFieldError('usuario')">
                </div>
                <span class="form-error" [ngClass]="{ 'show': shouldShowError('usuario') }">{{ getFieldError('usuario')
                    }}</span>
            </div>

            <!-- Contraseña Field -->
            <div class="form-group">
                <label for="contrasena" class="form-label">Contraseña</label>
                <div class="input-wrapper">
                    <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <input [type]="showPassword() ? 'text' : 'password'" id="contrasena" formControlName="contrasena"
                        class="form-input" [ngClass]="{
              'error': shouldShowError('contrasena'),
              'success': isFieldSuccess('contrasena')
            }" placeholder="Ingrese su contraseña" autocomplete="current-password" (blur)="markAsTouched('contrasena')"
                        (focus)="clearFieldError('contrasena')">
                    <button type="button" class="toggle-password" (click)="togglePassword()"
                        [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                        <svg class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            @if (!showPassword()) {
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                            } @else {
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                            }
                        </svg>
                    </button>
                </div>
                <span class="form-error" [ngClass]="{ 'show': shouldShowError('contrasena') }">{{
                    getFieldError('contrasena') }}</span>
            </div>

            <!-- Remember Me -->
            <div class="form-options">
                <label class="checkbox-label">
                    <input type="checkbox" formControlName="rememberMe">
                    <span class="checkbox-custom"></span>
                    <span class="checkbox-text">Recordarme</span>
                </label>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="submit-button" [ngClass]="{ 'loading': isLoading() }" [disabled]="isLoading()">
                <span class="button-text">Iniciar Sesión</span>
                <span class="button-loader"></span>
            </button>

            <!-- Message Area -->
            <div class="message-area" [ngClass]="{ 
          'show': errorMessage() || successMessage(),
          'error': errorMessage(),
          'success': successMessage()
        }">
                {{ errorMessage() || successMessage() }}
            </div>
        </form>

        <!-- Footer -->
        <footer class="login-footer">
            <p class="footer-text">© 2025 Suntur Quri Wasi. Todos los derechos reservados.</p>
        </footer>
    </div>
</main>